import { Tooltip } from "@/flokit/core/tooltip/tooltip";
import { ReactNode } from "react";
import { cn } from "../styling/cn";
import { DisabledWithTooltip } from "./disabled-with-tooltip";

interface DisabledWithTooltipWrapperProps
  extends Exclude<DisabledWithTooltip, boolean> {
  children: ReactNode;
}
export const DisabledWithTooltipWrapper = (
  props: DisabledWithTooltipWrapperProps
) => {
  if (!props.isDisabled || !props.message) return <>{props.children}</>;
  return (
    // https://www.radix-ui.com/docs/primitives/components/tooltip#displaying-a-tooltip-from-a-disabled-button
    <Tooltip
      content={props.message}
      align={props.align}
      side={props.side}
      asChild
    >
      <span
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        className={cn(
          // Width of <span> equal to width of its children
          "inline-block"
        )}
      >
        {props.children}
      </span>
    </Tooltip>
  );
};
